export const convertToUtc = (date) => {
  const dateArr = date?.split("-");

  let utcDate = new Date(
    Date.UTC(dateArr[0], Number(dateArr[1] - 1).toString(), dateArr[2]),
  );

  return utcDate.toLocaleDateString("en-US");
};
